import React, { useState, useEffect } from "react";
import BlogCard from "components/blog-card";
import { currentTab } from "store/blogCategories";
import { sanityClient } from "build/sanity";

const MoreNews = ({ data }) => {
  const { current } = currentTab();
  const [blogs, setBlogs] = useState([]);

  const fetchExtraBlogs = async (blogType) => {
    const stringBuilder = `
      *[_type == "blog" && "${blogType}" in categories[]->title] {
          ...,
          categories[]-> {
            ...
          }
        }[${blogs[blogType].data.length}...${(blogs[blogType].data.length + 2)}]
    `;

    const moreBlogs = await sanityClient.fetch(stringBuilder);

    if (moreBlogs.length === 0) {
      setBlogs((prevState) => ({
        ...prevState,
        [blogType]: { ...prevState[blogType], max: true }    
      }))
    } else {
      setBlogs((prevState) => ({
        ...prevState,
        [blogType]: { ...prevState[blogType], data: [...prevState[blogType].data, ...moreBlogs] }
      }))
    }
  }

  useEffect(() => {
    setBlogs(Object.fromEntries(
      Object.entries(data).filter(([key, value]) => {
        if (Array.isArray(value)) return true;
        return false;
      }).map(([key, value]) => [key, { data: value, max: false }])
    ))
  }, []);

  return (
    <div className="container">
      <div className="grid grid-cols-2 gap-x-32 gap-y-10 sm:grid-cols-1 sm:gap-x-0">
        {blogs[current]?.data.length > 0 &&
          blogs[current].data
            .map((blog, index) => (
              <BlogCard
                bigHeading={false}
                blog={blog}
                fullWidth={false}
                showParagraph={false}
                key={index} 
              />
            ))}
          {!blogs[current]?.max ? <button
            className="!bg-transparent btn btn-white !border-none my-9 mx-auto col-span-2 sm:col-span-1"
            onClick={() => fetchExtraBlogs(current)}
          >
            View more
          </button> : <p className="my-9 mx-auto col-span-2 sm:col-span-1"> The end </p> }
      </div>
    </div>
  );
};

export default MoreNews;
